// import something here

// leave the export, even if you don't use it

import { OARepo } from '@oarepo/invenio-oarepo-ui-vue'

import { OARepoQuasar } from '@oarepo/invenio-oarepo-ui-quasar'

export default (
  {
    app,
    router,
    store,
    Vue
  }
) => {
  let apiURL = process.env.VUE_APP_OAREPO_API_URL
  if (!apiURL.endsWith('/')) {
    apiURL += '/'
  }

  function preprocessItem (jsonObj, path) {
    if (path === undefined) {
      path = []
    }
    if (jsonObj !== null && typeof jsonObj === 'object') {
      path.push(jsonObj)
      Object.entries(jsonObj).forEach(([key, value]) => {
        if (key === '_files') {
          value.forEach(x => {
            x._record = path[path.length - 2]
          })
        } else {
          preprocessItem(value, path)
        }
      })
      path.pop()
    }
  }

  function getYear (input) {
    var parts = input.split('-')
    return parts[0]
  }

  const untranslatedFacets = {
    'category': true,
    'creator': true,
    'stylePeriod.title.value.keyword': true,
    'restorationRequestor.title.value.keyword': true,
    'itemType.title.value.keyword': true,
    'parts.restorationMethods.title.value.keyword': true,
    'parts.materialType.title.value': true,
    'parts.fabricationTechnology.title.value.keyword': true,
    'parts.color.title.value.keyword': true,
    'parts.materialType.title.value.keyword': true,
    'keywords': true,
    'works.metadata.restorationPeriod.until': true
  }

  Vue.use(OARepo, {
    apiURL,
    store,
    router,
    valueTranslator: (key, { type, facet, bucket }) => {
      if (facet === '_index') {
        key = key.replace('-v1.0.0', '')
      }
      if (facet === 'works.metadata.restorationPeriod.until') {
        return getYear(bucket.key_as_string)
      } else if (facet === 'creationPeriod.since') {
        return parseInt(bucket.key_as_string)
      } else if (facet === 'creationPeriod.until') {
        return parseInt(bucket.key_as_string)
      }
      if (untranslatedFacets[facet]) {
        return key
      }

      const tkey = []
      if (type === 'facet') {
        tkey.splice(0, 0, 'facets', key, 'label')
      } else if (type === 'bucket') {
        tkey.splice(0, 0, 'facets', facet, key)
      } else {
        console.error('No handler for type', type)
        return key
      }
      return app.i18n.t('facets.' + tkey.slice(1).join('_').replace(/[.]/g, '_'))
    },
    facetHandler: {
      facetKey (facet, value, bucket) {
        if (facet === 'works.metadata.restorationPeriod.until') {
          return bucket.label
        }
        return null
      },
      getRouter () {
        return router
      },
      showFacet (facet, value) {
        if (facet === 'creationPeriod.since' || facet === 'creationPeriod.until') {
          return false
        }
        return true
      }
    },
    itemPreprocessors: [
      (item, action) => {
        if (action === 'loaded') {
          preprocessItem(item)
        }
      }
    ]
  })
  Vue.use(OARepoQuasar)
}
